import { render, staticRenderFns } from "./BackofficeDataSolicitadaMedico.vue?vue&type=template&id=292ede48&scoped=true"
import script from "./BackofficeDataSolicitadaMedico.vue?vue&type=script&lang=ts"
export * from "./BackofficeDataSolicitadaMedico.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeDataSolicitadaMedico.vue?vue&type=style&index=0&id=292ede48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292ede48",
  null
  
)

export default component.exports